<template>
        <div class="wrap">
            <div class="p-al">
                <div class="d_f jc_sb al-list" v-if="list && list.length > 0">
                    <showCard v-for="item in list" :key="item.id" :img='item.projectPicUrl' :title="item.title" size='max' :to='"/case/details?id="+item.id'/>
                </div>
                <div class="d_f_1 jc_c" v-else>
                    <a-result status="500" title="暂时没有数据" sub-title="No data at present" />
                </div>
                <div class="pagewrap">
                    <Pagetion :pageSize='total'/> 
                </div>
            </div>

            <div class="m-al">
                <scroller v-if="list && list.length > 0" class="scroll"
                    :on-infinite="infinite" 
                    ref="caseScroller"
                >
                    <div class="scroll-content d_f jc_sb">
                        <div class="item" v-for="item in list" :key="item.id">
                            <showCard :img='item.projectPicUrl' :title="item.title" size='min' :to='"/case/details?id="+item.id' />
                        </div>
                    </div>
                </scroller>
                <div class="d_f_1 jc_c" v-else>
                    <a-result status="500" title="暂时没有数据" sub-title="No data at present" />
                </div>
            </div>
        </div>
</template>

<script>

import showCard from '../../components/show-card/index'
import Pagetion from '../../components/Pagetion/index.vue'
import index from './index'
export default {
    ...index,
    components : {
        showCard,
        Pagetion
    }
}
</script>

<style lang="scss" scoped>
    .wrap{
        width: 1200px;
        margin: 100px auto;
        flex-wrap: wrap;
        .al-list{
            flex-wrap: wrap;
        }
        .pagewrap{
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }
    .m-al{
        display: none;
    }

    @media screen and (max-width: 750px){
        .p-al{
            display: none;
        }
        .m-al{
            display: flex;
        }

        .wrap{
            width: 100%;
            margin:0 !important;
        }
        .scroll{
            top: 13.298vw !important;
            height:calc(100vh - 33.298vw) !important;
            background-color: #f8f8f8;
            .scroll-content{
                padding:3.989vw;
                flex-wrap: wrap;
                .item{
                    background-color: #fff;
                    border-radius: 1.33vw;
                    padding: 1.33vw;
                    margin-bottom: 2.66vw;
                }
                .fill{
                    width: 100%;
                    height: 26.596vw;
                    opacity: 0;
                }
            }
        }
    }
</style>